import api from './api';

/**
 * Send an email via MS Graph API through the portal backend
 * @param {Object} payload - Email payload
 * @param {string} payload.toEmail - Recipient email address
 * @param {string} [payload.toName] - Recipient display name
 * @param {string} payload.subject - Email subject
 * @param {string} payload.htmlContent - HTML email body
 * @param {string} [payload.textContent] - Plain text fallback
 * @param {Array} [payload.ccEmails] - CC recipients
 * @param {Array} [payload.bccEmails] - BCC recipients
 * @param {Array} [payload.categories] - Email categories
 * @returns {Promise<Object>} Response from server
 */
export const sendGraphMail = async (payload) => {
  try {
    const response = await api.post('/graph-mail/send', payload);
    const data = response.data || {};
    // If server indicates skipped or unsuccessful send, surface as error
    if (data.success === false) {
      const msg = data.message || 'Graph mail send was not completed';
      throw new Error(msg);
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to send email';
    throw new Error(message);
  }
};

/**
 * Save an email as draft via MS Graph API
 * @param {Object} payload - Email payload (same as sendGraphMail)
 * @returns {Promise<Object>} Response from server
 */
export const saveDraftGraphMail = async (payload) => {
  try {
    const response = await api.post('/graph-mail/draft', payload);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to save draft';
    throw new Error(message);
  }
};
